import React from "react";
import { toast } from "react-toastify";

// The end of every Read: "Read complete", the coin rows and Next Read.
// Display only: nothing is credited to the wallet yet.
//   rewards   { completion, firstAttemptBonus }
//   bonus     show the first-attempt bonus row
export default function ReadComplete({ rewards, bonus }) {
  return (
    <div className="text-center py-6">
      <h1 className="font-montserrat font-bold text-title-subpage text-pageTitle">Read complete</h1>
      <div className="mt-5 flex flex-col items-center gap-2">
        <RewardRow amount={rewards.completion} label="coins" />
        {bonus && <RewardRow amount={rewards.firstAttemptBonus} label="first-attempt bonus" />}
      </div>
      <button
        type="button"
        // The next Read is not built yet; the primary action is shown so the
        // completion state can be reviewed as designed.
        onClick={() => toast.info("The next Read is not part of this prototype.")}
        className="mt-6 w-full min-h-[44px] rounded-lg bg-primaryColor text-white font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1A1A1A]"
      >
        Next Read
      </button>
    </div>
  );
}

function RewardRow({ amount, label }) {
  return (
    <p className="flex items-center gap-2 text-base font-semibold text-bodyInk">
      <span aria-hidden="true" className="inline-block w-5 h-5 rounded-full bg-[#D7C588] border border-[#004C50]" />
      +{amount} {label}
    </p>
  );
}
